import type { ElementType, HTMLAttributes, ReactNode } from "react";
import { cx } from "../../lib/cx";
import styles from "./Typography.module.css";

type DisplayProps = { as?: ElementType; children: ReactNode } & HTMLAttributes<HTMLElement>;

export const Display = ({ as: As = "h1", className, children, ...rest }: DisplayProps) => (
  <As className={cx(styles.display, className)} {...rest}>
    {children}
  </As>
);

type HeadingLevel = 1 | 2 | 3 | 4;
type HeadingProps = { level?: HeadingLevel; children: ReactNode } & HTMLAttributes<HTMLElement>;

export const Heading = ({ level = 2, className, children, ...rest }: HeadingProps) => {
  const Tag = `h${level}` as ElementType;
  return (
    <Tag className={cx(styles.heading, styles[`h${level}`], className)} {...rest}>
      {children}
    </Tag>
  );
};

type TextProps = { children: ReactNode } & HTMLAttributes<HTMLParagraphElement>;

export const Body = ({ className, children, ...rest }: TextProps) => (
  <p className={cx(styles.body, className)} {...rest}>
    {children}
  </p>
);

type InlineProps = { children: ReactNode } & HTMLAttributes<HTMLSpanElement>;

export const Kicker = ({ className, children, ...rest }: InlineProps) => (
  <span className={cx(styles.kicker, className)} {...rest}>
    {children}
  </span>
);

export const Muted = ({ className, children, ...rest }: InlineProps) => (
  <span className={cx(styles.muted, className)} {...rest}>
    {children}
  </span>
);

export const Mono = ({ className, children, ...rest }: InlineProps) => (
  <span className={cx(styles.mono, className)} {...rest}>
    {children}
  </span>
);
